import sheetOnePage from '@/pages/sheetPage/sheetOne';

import sheetOneMeeting from '@/components/sheet/sheetOne/sheetMeeting';
import sheetOneReflection from '@/components/sheet/sheetOne/sheetReflection';
import sheetOneDecision from '@/components/sheet/sheetOne/sheetDecision';

export default {
    path: '/arkusz1/:familyId',
    props: true,
    component: sheetOnePage,
    meta: { requiresAuth: true },
    children: [
        {
            path: 'spotkanie',
            component: sheetOneMeeting,
            name: 'sheet-one-meeting',
            meta: { requiresAuth: true }
        },
        {
            path: 'refleksja',
            component: sheetOneReflection,
            name: 'sheet-one-reflection',
            meta: { requiresAuth: true }
        },
        {
            path: 'decyzja',
            component: sheetOneDecision,
            name: 'sheet-one-decision',
            meta: { requiresAuth: true }
        }
    ]
};
